if (!customElements.get('article-editorial')) {
  customElements.define('article-editorial', class extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => this.initialize());
    }

    initialize() {
      const content = this.querySelector('.article__content');
      if (!content) return;

      // Keep comparison tables readable on small screens without widening the page.
      content.querySelectorAll('table').forEach((table) => {
        if (table.parentElement.classList.contains('article-table-scroll')) return;
        const wrapper = document.createElement('div');
        wrapper.className = 'article-table-scroll';
        wrapper.tabIndex = 0;
        table.before(wrapper);
        wrapper.append(table);
      });

      const list = this.querySelector('[data-article-toc]');
      const sidebar = this.querySelector('[data-article-sidebar]');
      if (!list || !sidebar) return;
      let headings = [...content.querySelectorAll('h2')];
      if (!headings.length) headings = [...content.querySelectorAll('h3')];
      this.headings = headings.filter((heading) => heading.textContent.trim());
      list.replaceChildren();
      sidebar.hidden = !this.headings.length;
      if (!this.headings.length) return;

      this.links = this.headings.map((heading, index) => {
        if (!heading.id) {
          const base = `article-section-${index + 1}`;
          let id = base;
          let suffix = 1;
          while (document.getElementById(id)) id = `${base}-${suffix++}`;
          heading.id = id;
        }
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = `#${encodeURIComponent(heading.id)}`;
        link.textContent = heading.textContent.trim();
        item.append(link);
        list.append(item);
        return link;
      });
      this.updateActive = () => {
        this.scrollFrame = null;
        const offset = parseFloat(getComputedStyle(this.headings[0]).scrollMarginTop) || 100;
        let active = 0;
        this.headings.forEach((heading, index) => {
          if (heading.getBoundingClientRect().top <= offset + 16) active = index;
        });
        this.links.forEach((link, index) => {
          if (index === active) link.setAttribute('aria-current', 'location');
          else link.removeAttribute('aria-current');
        });
      };
      this.onScroll = () => {
        if (this.scrollFrame == null) this.scrollFrame = requestAnimationFrame(this.updateActive);
      };
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.updateActive();
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      cancelAnimationFrame(this.scrollFrame);
      if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
    }
  });
}
